import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import {setSelectedFilters} from "../../../../actions/actionFunctions";
import {setGroheFiltersSearchText} from "../../../../actions/groheFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";


const LookFiltersReset = (props) => {
  const {setSelectedFilters, intl, setGroheFiltersSearchText} = props;

  const resetFilterClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeaturesFiltersReset);
    setSelectedFilters([]);
    setGroheFiltersSearchText("");
  };

  //console.log("availableFilters", availableFilters);

  return (
    <div className="lk-reset__container">
      <IconButton aria-label={intl.formatMessage({id:"iconButton.close"})}
                  className="look-icon look-icon--small look-icon--active"
                  onClick={resetFilterClick}>
        <RestartAltIcon/>
      </IconButton>
      <span className="lk-reset__container-text" onClick={resetFilterClick}>
        <FormattedMessage id="look.features.recommend.resetButton"/>
      </span>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  const {showFilters} = store.filterState;
  return {
    filtersOpened: showFilters,
    lookActiveFeature,
  };
};

const mapDispatchToProps = {
  setSelectedFilters,
  setGroheFiltersSearchText,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFiltersReset)
);
